import { render, staticRenderFns } from "./competitor.vue?vue&type=template&id=2e5fd552&scoped=true"
import script from "./competitor.vue?vue&type=script&lang=js"
export * from "./competitor.vue?vue&type=script&lang=js"
import style0 from "./competitor.vue?vue&type=style&index=0&id=2e5fd552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5fd552",
  null
  
)

export default component.exports